export enum RATING_TYPE {
  CLINIC = 'clinic',
  SPECIALIST = 'specialist'
}
